import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Mail, Shield, TrendingUp } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-card/50 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 rounded-sm bg-gradient-to-br from-red-500 to-orange-500 flex items-center justify-center">
                <Activity className="w-5 h-5 text-white" />
              </div>
              <span className="font-display text-lg font-bold tracking-tight uppercase">
                SportsAnalysisAB
              </span>
            </div>
            <p className="text-sm text-muted-foreground max-w-md">
              Alberta's premier sports analytics platform. Statistical game previews and probability 
              estimates for educational and entertainment purposes.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-display font-bold uppercase tracking-wider text-sm mb-4">Navigate</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/board" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Game Board
                </Link>
              </li>
              <li>
                <Link to="/accuracy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Accuracy Report
                </Link>
              </li>
              <li>
                <Link to="/methodology" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Our Methodology
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-display font-bold uppercase tracking-wider text-sm mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/responsible-gaming" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Responsible Gaming
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 pt-6 border-t border-border">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Shield className="w-4 h-4" />
              <span>18+ Only. For entertainment purposes only. Not a gambling service.</span>
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Mail className="w-4 h-4" />
              <Link to="/contact" className="hover:text-foreground transition-colors">
                Contact Us
              </Link>
            </div>
          </div>
          <p className="text-xs text-muted-foreground/60 mt-4">
            &copy; {new Date().getFullYear()} SportsAnalysisAB. All rights reserved. 
            Not affiliated with any professional sports leagues or gambling organizations.
          </p>
        </div>
      </div>
    </footer>
  );
};
